import { render, staticRenderFns } from "./VFDTransactionQuery.vue?vue&type=template&id=b84cc22e&scoped=true&"
import script from "./VFDTransactionQuery.vue?vue&type=script&lang=js&"
export * from "./VFDTransactionQuery.vue?vue&type=script&lang=js&"
import style0 from "./VFDTransactionQuery.vue?vue&type=style&index=0&id=b84cc22e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84cc22e",
  null
  
)

export default component.exports